module.exports = __webpack_public_path__ + "img/gzhj_07.cb3de9a6.jpg";